import React from 'react';
import { Badge, Box, Divider, Heading, SimpleGrid, Text } from '@chakra-ui/react';

const Step5ReviewSave = ({
                             name,
                             productId,
                             shouldSyncWithWooCommerce,
                             showData,
                             useAdvancedOptions,
                             useOptionId,
                             options,
                             useSummary,
                         }) => {
    const summaryItems = [
        ['Product Name', name || 'Not specified'],
        ['Product ID', productId || 'Not specified'],
        ['Sync with WooCommerce', shouldSyncWithWooCommerce ? 'Yes' : 'No'],
        ['Show Orders', showData ? 'Yes' : 'No'],
        ['Use Advanced Options', useAdvancedOptions ? 'Yes' : 'No'],
        ['Use Option ID', useOptionId ? 'Yes' : 'No'],
        ['Use Summary', useSummary ? 'Yes' : 'No'],
    ];

    return (
        <Box>
            <Heading as="h4" size="md" mb="2">
                Review product
            </Heading>
            <Text color="gray.500" mb="6">
                Check the product setup before saving. You can still go back to adjust anything.
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing="4" mb="6">
                {summaryItems.map(([label, value]) => (
                    <Box key={label} p="4" borderWidth="1px" borderRadius="xl" bg="gray.50">
                        <Text fontSize="xs" color="gray.500" fontWeight="700" textTransform="uppercase">
                            {label}
                        </Text>
                        <Text mt="1" fontWeight="700" color="gray.800">
                            {value}
                        </Text>
                    </Box>
                ))}
            </SimpleGrid>

            <Divider my="4" />

            <Heading as="h4" size="md" mb="4">
                Product Options
            </Heading>

            {options.length > 0 ? (
                options.map((option, index) => (
                    <Box key={index} mb="5" p="5" borderWidth="1px" borderRadius="2xl" bg="white" boxShadow="sm">
                        <Badge colorScheme="blue" borderRadius="full" mb="3">
                            Option {index + 1}
                        </Badge>
                        <Text fontWeight="bold" mb="3">{option.name || 'Untitled option'}</Text>
                        <SimpleGrid columns={{ base: 1, md: 2 }} spacing="4">
                            <Text>Value: <strong>{option.value || 'Not specified'}</strong></Text>
                            <Text>Quantity: <strong>{option.quantity || 'Not specified'}</strong></Text>
                            <Text>Catch Phrase: <strong>{option.catch_phrase || 'Not specified'}</strong></Text>
                            <Text>Reduced Price: <strong>{option.reduced_price || 'Not specified'}</strong></Text>
                            <Text>Preselected: <strong>{option.preselected ? 'Yes' : 'No'}</strong></Text>
                            <Text>Free shipping: <strong>{option.free_shipping ? 'Yes' : 'No'}</strong></Text>

                            {useOptionId && option.productIds.length > 0 && (
                                <Text>Product IDs: <strong>{option.productIds.join(', ')}</strong></Text>
                            )}

                            {option.colors?.length > 0 && (
                                <Box>
                                    <Text fontWeight="bold">Colors:</Text>
                                    {option.colors.map((color, colorIndex) => (
                                        <Text key={colorIndex}>
                                            - {color.color || 'No color specified'} (WooCommerce Product ID: {color.woocommerce_product_id || 'N/A'})
                                        </Text>
                                    ))}
                                </Box>
                            )}

                            {option.imageUrl && (
                                <Box>
                                    <Text>Image: </Text>
                                    <img src={option.imageUrl} alt={`Option ${index + 1}`} width="100px" height="100px" />
                                </Box>
                            )}
                        </SimpleGrid>
                    </Box>
                ))
            ) : (
                <Text>No product options specified.</Text>
            )}

            <Divider my="6" />
        </Box>
    );
};

export default Step5ReviewSave;